(function () {
    'use strict';

    angular
        .module('salesflare')
        .config(function ($mdPanelProvider) {

            $mdPanelProvider.definePreset('notificationPanel', {
                clickOutsideToClose: true,
                controller: 'NotificationsController',
                controllerAs: 'vm',
                templateUrl: 'app-ajs/components/notification/notificationPanel.html',
                panelClass: 'notification-panel'
            });
        });
})();
